<template>
  <V2AtomsBaseCard
    size="x-small"
    radius="small"
    class="h-fit cursor-pointer flex flex-col flex-grow items-center justify-center gap-1 border-semantic-util-transparent !min-w-[9rem] !max-w-full md:!max-w-[11rem] md:!min-w-[11rem] hover:!bg-semantic-surface-container-lowest shadow-combined-elevation-1"
    :data-testid="dataTestid"
  >
    <!-- eslint-disable vue/no-v-html -->
    <img
      v-if="imagePath"
      :src="imagePath"
      class="rounded-2xl w-[5rem] h-[4.375rem]"
      alt="header-card"
    />

    <div
      v-if="title"
      class="font-bold text-sm/[150%] md:text-base/[150%] text-center text-semantic-primary-variant-light"
      v-html="title"
    />
    <!-- eslint-enable vue/no-v-html -->
  </V2AtomsBaseCard>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesCardHeroCard'
})

defineProps({
  dataTestid: {
    type: String,
    default: 'hero-card-section'
  },

  title: {
    type: String,
    default: ''
  },

  imagePath: {
    type: String,
    default: ''
  }
})
</script>
